<template>
    <div>

        <Stepper v-model="step" :steps="2">
            <template slot="1">
                <h1 class="mb-8">Qual o seu nome?</h1>
                <div class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4">
                    <vs-input v-model="user.name" v-validate="'required'" 
                        name="Nome Completo" class="w-full" icon-pack="feather" icon="icon-user" 
                        icon-no-border label="NOME COMPLETO" placeholder="Ex.: Maria Aparecida da Penha"
                        @keyup.enter="() => !invalid && step++"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('Nome Completo')">{{ errors.first('Nome Completo') }}</span>
                </div>
            </template>

            <template slot="2">

                <div v-if="hasEmail === null">
                    <h2 class="mb-8">Bem vindo(a) <span class="text-primary"><b>{{user.name}}</b></span>!</h2>
                    <h3 >Você possui e-mail?</h3>
                    <div class="mt-8 sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-4 flex items-center justify-between">
                        <vs-button @click="hasEmail = true"> <a-icon type="check" /> Sim</vs-button>
                        <vs-button @click="setAsNoEmail" type="border"> <a-icon type="close" /> Não</vs-button>
                    </div>
                </div>
                <div v-if="hasEmail" class="sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 m mb-4">
                
                    <h3>Informe seu e-mail</h3>
                    <vs-input v-validate="'required|email'" name="email" class="w-full" icon-pack="feather" icon="icon-at-sign" icon-no-border label="EMAIL" placeholder="nome@hotmail.com" v-model="user.email"></vs-input>
                    <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
                    <h3 class="mt-8">Defina sua senha</h3>
                    <PasswordDefiner
                        @changed="(v) => passwordModal.password = v"
                        @valid="(v) => passwordModal.valid = v"/>

                </div>

                <div v-if="hasEmail === false">
                    <h6>Já que não possui email, use o email abaixo apenas para usar o Pedido Rápido:</h6>
                    <h2  class="my-6" style="word-break: break-all;">{{ generatedEmail }}</h2>
                    <h5 v-show="!userRedefined" class="mt-4">Também criamos sua senha:</h5>
                    <div class="flex items-center mb-2">
                        <h5 v-show="userRedefined">A senha foi definida</h5>
                        <h2 v-show="!userRedefined" class="mt-2">{{ generatedPassword }}</h2>
                        <vs-button type="flat" class="mb-1" @click="changePassword"> <a-icon type="edit"/> Trocar a senha</vs-button>
                    </div>

                    <h6 class="mb-5">Anote estas informações!</h6>

                    <a-modal :visible="passwordModal.show"
                        @cancel="passwordModal.show = false"
                        @ok="definePassword"
                        :okButtonProps="{ props: { disabled: !passwordModal.valid } }"
                        title="Definir senha">
                        
                        <PasswordDefiner v-if="passwordModal.show"
                            style="width: 50%"
                            @changed="(v) => passwordModal.password = v"
                            @valid="(v) => passwordModal.valid = v"/>

                    </a-modal>

                </div>
            </template>
        </Stepper>

        <div class="full-width flex justify-end ">
            <vs-button :disabled="step === 1" @click="back" class="mr-3" type="flat" > <a-icon type="left"/> voltar</vs-button>
            <vs-button :disabled="step === 2 || invalid" @click="step++" v-show="step == 1"> 
                Próximo
                <a-icon type="right"/>
            </vs-button>
            <vs-button v-show="step == 2 && hasEmail != null"
                :disabled="invalid || busy" color="success"
                @click="createUser">
                Solicitar acesso
                <a-icon type="check"/> 
            </vs-button>
        </div>       
        <!-- <vs-avatar id="imageUpload" :text="nameScaped" size="70px" class="mr-4 mb-4" /> -->
    </div>
</template>

<script>
    import { createInvite, createEmailUser } from '@/user';
    import util from '../../../../assets/utils/misc';
    import Stepper from '../../../../components/Stepper';
    import PasswordDefiner from './PasswordDefiner.vue';

    export default {
        components: {Stepper, PasswordDefiner},
        props: {
                company: {
                type: Object,
            },
        },
        data() {
            return {
                user: {
                    name: '',
                    email: '',
                    password: '',
                },
                passwordModal: {
                    show: false,
                    valid: false,
                    password: '',
                },
                userRedefined: false,
                step: 1,
                hasEmail: null,
                busy: false
            }
        },
        computed: {
            nameScaped () { return util.removeSpecialChars(this.user.name); },
            emailPrefix () { return this.nameScaped.toLowerCase().replaceAll(' ', '.'); },
            generatedPassword () { return Math.random().toString(10).substr(2, 6); },
            generatedEmail () {
                // TODO: check if exists
                const { emailPrefix, company } = this;
                return `${emailPrefix}@${company.id}.com.br`;
            },
            invalid () {
                return !this.nameScaped.length || !this.user.name.length || (this.hasEmail && (!this.passwordModal.valid || this.errors.has('email')))
            },
        },
        methods: {
            back() {
                this.hasEmail = null;
                this.step--;
            },
            changePassword () {
                this.passwordModal.password = '';
                this.passwordModal.passwordMirror = null;
                this.passwordModal.valid = false;
                this.passwordModal.show = true;
            },
            definePassword () {
                this.user.password = this.passwordModal.password;
                this.userRedefined = true;
                this.passwordModal.show = false;
            },
            async setAsNoEmail () {
                try {
                    this.fetchingEmail = true;
                } finally {
                    this.fetchingEmail = false;
                }
                this.hasEmail = false;
            },
            async createUser () {
                try {
                    this.busy = true;
                    const { hasEmail, passwordModal, generatedEmail } = this;
                    if (!hasEmail) {
                        try {
                            await new Promise((res, rej) => {
                                this.$confirm({
                                    title: 'Lembre-se!',
                                    content: `Como você não possui email, o endereço ${generatedEmail} foi criado APENAS para acessar o Pedido Rápido. Este email NÃO EXISTE e você NÃO conseguirá alterar a senha.`,
                                    cancelText: 'Cancelar',
                                    onOk: () => res(),
                                    onCancel: () => rej(),
                                    onDismiss: () => rej()
                                });
                            });
                        } catch {
                            return;
                        }
                    }
                    this.$vs.loading();
                    const { email, password, name } = this.user;
                    // const user = this.$store.getters.getUserStoredData;
                    const user = await createEmailUser(name, hasEmail ? email : generatedEmail, hasEmail ? passwordModal.password : password);
                    this.$store.commit('SET_USER', user);
                    await createInvite(this.company.id)
                    this.$emit('userCreated');
                } catch (err) {
                    this.$vs.dialog({
                        type: 'alert',
                        color : 'primary',
                        title : 'Erro ao criar usuário',
                        acceptText : 'Fechar',
                        text : err.message
                    })
                } finally {
                    this.busy = false;
                    this.$vs.loading.close();
                }
            }
        },
        mounted () {
            this.user.password = this.generatedPassword;
        },
    }
</script>

<style lang="scss" scoped>

</style>